import { useMemo } from 'react';
import {
  formatLocalDate,
  formatLocalDateTime,
  formatUtcDate,
  formatUtcDateTime,
} from './format-date';
import { useIsClient } from './use-is-client';

export type DateFormatters = {
  formatDate: (value: string | Date) => string;
  formatDateTime: (value: string | Date) => string;
};

const UTC_FORMATTERS: DateFormatters = {
  formatDate: formatUtcDate,
  formatDateTime: formatUtcDateTime,
};

const LOCAL_FORMATTERS: DateFormatters = {
  formatDate: (value) => formatLocalDate(value),
  formatDateTime: (value) => formatLocalDateTime(value),
};

export function useDateFormatters(): DateFormatters {
  const isClient = useIsClient();
  return useMemo(() => (isClient ? LOCAL_FORMATTERS : UTC_FORMATTERS), [isClient]);
}
